import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { useLocation, useNavigate } from "react-router-dom";
import AddNOtes from "./lead-actions/add_notes";
import api from "../../../services/api";
import { showBasicAlert } from "../../../core/common/useAlert";
import { useSelector } from "react-redux";
import { DatePicker } from "antd";
import { Menu, MenuItem, IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import EditLead from "./editLead";
import { humanReadableDate } from "../../../helper/dateTimeHelper";
import { WhatsAppConversationPanel } from "../../../core/common/whatsapp-conversation/WhatsAppConversationPanel";

interface FormField {
  id: string;
  label: string;
  type: "text" | "select";
  options?: string[];
}

interface FormData {
  structure: FormField[];
  responses?: { [key: string]: string };
}

interface ExtraInfo {
  reminder: string;
  priority: string;
  assignedTo: {
    name: string;
    avatar: string;
  };
}

interface Activity {
  id: number;
  type: string;
  icon: string;
  bgColor: string;
  title: string;
  time: string;
  description?: string;
  extraInfo?: ExtraInfo;
  acitivityBy?: any;
}

interface ActivityLogGroup {
  date: string;
  activities: Activity[];
}

const SORT_KEYS = ["Country", "State", "District", "City"];
const STATUS_OPTIONS = ["Busy", "Missed", "Outgoing", "Incoming", "Voice Message", "Rejected"];
const PRIORITY_OPTIONS = ["High", "Medium", "Low"];

const LeadsDetails = () => {
  const user = useSelector((state: any) => state.user.user);
  const location = useLocation();
  const navigate = useNavigate();
  const routes = all_routes;
  const signature = localStorage.getItem("signature");

  const lead = location.state?.lead || {};
  const formData = location.state?.data || [];
  const pipelines = location.state?.pipelines || [];
  const pipelinesConfig = location.state?.pipelinesConfig || [];
  const comingFromtype = location.state?.type || "grid";
  const selectedCompanyDetails = location.state?.selectedCompanyDetails;
  const selectedLeadFormDetails = location.state?.selectedLeadFormDetails;

  const [isLoading, setIsLoading] = useState(false);
  const [isWhatsAppTabOpened, setIsWhatsAppTabOpened] = useState(false);
  const [notes, setNotes] = useState<any[]>([]);
  const [callLogs, setCallLogs] = useState<any[]>([]);
  const [activityLogs, setActivityLogs] = useState<ActivityLogGroup[]>([]);
  const [showEditor, setShowEditor] = useState<{ [key: number]: boolean }>({});
  const [newComments, setNewComments] = useState<{ [key: number]: string }>({});
  const [selectedDate, setSelectedDate] = useState(null);
  const [showStageReminderModal, setShowStageReminderModal] = useState(false);
  const [pendingStageChange, setPendingStageChange] = useState<string | null>(null);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [selectedLead, setSelectedLead] = useState<FormData | null>(null);
  const [priority, setPriority] = useState(lead.priority);
  const [previousCompany, setPreviousCompany] = useState(selectedCompanyDetails);
  const [previousForm, setPreviousForm] = useState(selectedLeadFormDetails);
  const [pipeLineDetail, setpipeLineDetail] = useState(pipelines);
  const [formDetail, setformDetail] = useState(formData);

  const sortResponseData = (data: any) => {
    const responseData = data.response || {};
    const sortedResponse = {
      ...Object.fromEntries(
        SORT_KEYS.filter((key) => key in responseData).map((key) => [key, responseData[key]])
      ),
      ...responseData,
    };
    return { ...data, response: sortedResponse };
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const [leadDetail, setleadDetail] = useState(sortResponseData(lead));

  const createApiPayload = (additionalData = {}) => ({
    signature,
    lead_id: leadDetail.id || leadDetail?.key,
    company_id: leadDetail.company_id,
    company_type: leadDetail.company_type,
    ...additionalData,
  });

  const closeModal = (modalId: string) => {
    const modalElement = document.getElementById(modalId);
    if (modalElement) {
      const modalBackdrop = document.querySelector('.modal-backdrop');
      if (modalBackdrop) {
        modalBackdrop.remove();
      }
      modalElement.classList.remove('show');
      modalElement.style.display = 'none';
      document.body.classList.remove('modal-open');
      document.body.style.removeProperty('overflow');
      document.body.style.removeProperty('padding-right');
    }
  };

  const refreshPage = async () => {
    setIsLoading(true);
    try {
      const [leadResponse, getLeadnote, getLeadCalls, leadActivities] = await Promise.all([
        api.post("leadService/getLeadById", {
          signature,
          lead_id: leadDetail.id || leadDetail.key,
        }),
        api.post("leadService/getLeadNote", createApiPayload()),
        api.post("leadService/getLeadCalls", createApiPayload()),
        api.post("leadService/getLeadActivities", { signature, lead_id: leadDetail.id || leadDetail.key }),
      ]);

      const fetchedLead = leadResponse.data.data.data;
      const sortedData = sortResponseData(fetchedLead);
      setleadDetail(sortedData);
      setPriority(sortedData.priority);
      setNotes(getLeadnote.data.data.data);
      setCallLogs(getLeadCalls.data.data.data);
      setActivityLogs(leadActivities.data.data.data);

      scrollToTop();

    } catch (err) {

    } finally {
      setIsLoading(false);
    }
  };

  const fetchActivities = async () => {
    setIsLoading(true);
    try {
      const [getLeadnote, getLeadCalls, leadActivities] = await Promise.all([
        api.post("leadService/getLeadNote", createApiPayload()),
        api.post("leadService/getLeadCalls", createApiPayload()),
        api.post("leadService/getLeadActivities", { signature, lead_id: leadDetail.id || leadDetail.key }),
      ]);
      setNotes(getLeadnote.data.data.data);
      setCallLogs(getLeadCalls.data.data.data);
      setActivityLogs(leadActivities.data.data.data);
    } catch (err) {
    } finally {
      setIsLoading(false);
    }
  };

  const fetchLeadById = async (leadId: string) => {
    try {
      setIsLoading(true);
      const response = await api.post("leadService/getLeadById", {
        signature,
        lead_id: leadId,
      });
      const fetchedLead = response?.data?.data?.data;
      const sortedData = sortResponseData(fetchedLead);
      setleadDetail(sortedData);
      setPriority(sortedData?.priority);
      return sortedData;
    } catch (error: any) {
      const errorMessage = error?.data?.message?.[0]?.msg || "Failed to fetch lead!";
      showBasicAlert(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const initialize = async () => {
      try {
        if (lead?.key) {
          await fetchLeadById(lead.key);
        }
        await fetchActivities();
      } catch (err) {
      }
    };
    initialize();
  }, []);

  const handlePriorityChange = async (newPriority: any) => {
    try {
      setPriority(newPriority);
      const response = await api.post("leadService/updateLeadPriority", {
        signature,
        priority: newPriority,
        id: leadDetail.key || leadDetail?.id,
      });
      showBasicAlert(response?.data?.message?.[0]?.msg);
    } catch (error: any) {
      const errorMessage = error?.data?.message?.[0]?.msg || "Failed to update priority!";
      showBasicAlert(errorMessage);
    }
  };

  const handleOpenEditor = (index: number) => {
    setShowEditor((prev) => ({ ...prev, [index]: true }));
  };

  const handleCloseEditor = (index: number) => {
    setShowEditor((prev) => ({ ...prev, [index]: false }));
    setNewComments((prev) => ({ ...prev, [index]: "" }));
  };

  const handleCommentChange = (index: number, value: string) => {
    setNewComments((prev) => ({ ...prev, [index]: value }));
  };

  const handleSaveComment = async (noteId: number, index: number) => {
    if (!newComments[index]) return;
    try {
      setIsLoading(true);
      const dataToSubmit = {
        signature,
        id: noteId,
        comment: newComments[index],
        date: new Date().toISOString(),
        name: `${user.userDetails.salutation} ${user.userDetails.fname} ${user.userDetails.lname}`,
        profile_pic: user.userDetails.profile_pic || "N/A",
      };
      const response = await api.post("leadService/addLeadnotecomment", dataToSubmit);
      showBasicAlert(response?.data?.message?.[0]?.msg);
      setShowEditor((prev) => ({ ...prev, [index]: false }));
      setNewComments((prev) => ({ ...prev, [index]: "" }));
      await refreshPage();
    } catch (error: any) {
      const errorMessage = error?.data?.message?.[0]?.msg || "Failed to add comment!";
      showBasicAlert(errorMessage);
      setIsLoading(false);
    }
  };

  const handleStatusChange = async (id: number, newStatus: string) => {
    setCallLogs((prevLogs) =>
      prevLogs.map((log) => (log.id === id ? { ...log, status: newStatus } : log))
    );
    try {
      const response = await api.post("leadService/udpdateLeadCalls", {
        signature,
        id,
        call_type_status: newStatus,
      });
      showBasicAlert(response?.data?.message?.[0]?.msg);
    } catch (error: any) {
      const errorMessage = error?.data?.message?.[0]?.msg || "Failed to change status!";
      showBasicAlert(errorMessage);
    }
  };

  const handleDateChange = (date: any) => {
    setSelectedDate(date);
  };

  const handleSubmit = async () => {
    if (!selectedDate) {
      showBasicAlert("Please select a date");
      return;
    }

    try {
      setIsLoading(true);
      const result = await api.post("leadService/addLeadFollowUp", {
        ...createApiPayload(),
        follow_up_date: selectedDate,
      });
      showBasicAlert(result?.data?.message?.[0]?.msg);
      setSelectedDate(null);
      closeModal("add_follow_up");
      await refreshPage();
    } catch (error: any) {
      const errorMessage = error?.data?.message?.[0]?.msg || "Failed to add lead follow up!";
      showBasicAlert(errorMessage);
      setIsLoading(false);
    }
  };

  const handleStageReminderSubmit = async () => {
    try {
      setIsLoading(true);
      if (selectedDate && pendingStageChange) {
        await api.post("leadService/addLeadFollowUp", {
          ...createApiPayload(),
          follow_up_date: selectedDate,
        });
        showBasicAlert("Follow-up reminder added successfully");
      }
      setShowStageReminderModal(false);
      setSelectedDate(null);
      setPendingStageChange(null);
      await refreshPage();
    } catch (error: any) {
      const errorMessage = error?.data?.message?.[0]?.msg || "Failed to add reminder!";
      showBasicAlert(errorMessage);
      setIsLoading(false);
      setShowStageReminderModal(false);
      setSelectedDate(null);
      setPendingStageChange(null);
    }
  };

  const handleStageReminderSkip = async () => {
    setShowStageReminderModal(false);
    setSelectedDate(null);
    setPendingStageChange(null);
    await refreshPage();
  };


  const handleMenuOpen = (event: any, lead: any) => {
    setAnchorEl(event.currentTarget);
    setSelectedLead(lead);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleEditLead = () => {
    setIsEditOpen(true);
    handleMenuClose();
  };

  const handleCloseEdit = async () => {
    setIsEditOpen(false);
  };

  const handleUpdateLead = async () => {
    setIsEditOpen(false);
    await refreshPage();
  };

  const handleNotesAdded = async () => {
    try {
      setIsLoading(true);
      closeModal("add_notes");
      await refreshPage();
    } catch (error) {
      setIsLoading(false);
    }
  };

  const updateStage = async (stage: any) => {
    const stageConf = pipelinesConfig.find(
      (c: any) => c.stage_name?.toLowerCase().trim() === stage.toLowerCase().trim()
    ) || {};
    const shouldShowReminder = stageConf.require_reminder !== false;

    try {
      await api.post("leadService/updateLeadResponsePipeline", {
        signature,
        pipeline: stage,
        lead_id: leadDetail.key || leadDetail?.id,
      });

      const updatedLead = { ...leadDetail, pipeline_char: stage };
      setleadDetail(updatedLead);

      if (!shouldShowReminder) {
        await refreshPage();
      } else {
        setPendingStageChange(stage);
        setShowStageReminderModal(true);
      }

    } catch (error: any) {
      const errorMessage = error?.data?.message?.[0]?.msg || "Failed to update stage!";
      showBasicAlert(errorMessage);
    }
  };

  const getRouteByType = () => {
    const routeMap: any = {
      lead_grid: routes.leadsGrid,
      deal_grid: routes.dealsGrid,
      lead_list: routes.leadsList,
      deal_list: routes.dealsList,
    };
    return routeMap[comingFromtype] || routes.dealsList;
  };

  const getTypeLabel = () => {
    return comingFromtype.includes("deal") ? "Deals" : "Leads";
  };

  return (
    <>
      <div className="page-wrapper">

        {isLoading ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ minHeight: "90vh" }}
          >
            <div className="spinner-border text-primary" role="status">

            </div>
          </div>
        ) : (<div className="content">
          <div className="row align-items-center mb-4">
            <div className="col-sm-6">
              <div className="d-flex align-items-center flex-wrap row-gap-3">
                <h6 className="fw-medium d-inline-flex align-items-center me-2">
                  <Link
                    to={`${getRouteByType()}${location?.search}`}
                    state={{
                      companyDetails: previousCompany,
                      formDetails: previousForm,
                      preserveFilters: location.state?.preserveFilters
                    }}>
                    <i className="ti ti-arrow-left me-2" />
                    {getTypeLabel()}
                  </Link>
                  <span className="text-gray d-inline-flex ms-2">
                    / {leadDetail.response["Full Name"]}
                  </span>
                </h6>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="d-flex justify-content-sm-end">
                <div className="head-icons ms-2">
                  <CollapseHeader />
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-xl-4 theiaStickySidebar">
              <div className="card card-bg-1 sticky-class">
                <div className="card-body p-0">
                  <span className="avatar avatar-xl border text-dark bg-white rounded-circle m-auto d-flex mb-2">
                    {leadDetail?.response["Full Name"]
                      ?.split(" ")
                      ?.map((word: any) => word[0])
                      ?.join("")
                      ?.toUpperCase()}
                  </span>
                  <div className="text-center px-3 pb-3 border-bottom">
                    <h5 className="d-flex align-items-center justify-content-center mb-1">
                      {leadDetail.response["Full Name"]}
                      <span className="avatar avatar-sm avatar-rounded bg-light ms-2">
                        <i className="ti ti-star-filled text-warning fs-14" />
                      </span>
                    </h5>
                    <div className="d-flex align-items-center justify-content-center">
                      <span className="badge badge-danger-transparent">
                        {leadDetail.pipeline_char}
                      </span>
                    </div>
                  </div>

                  <div className="p-3 border-bottom">
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <h6>Lead information</h6>
                      <div className="ms-auto">
                        <IconButton
                          aria-label="edit"
                          size="small"
                          onClick={(event) =>
                            handleMenuOpen(event, {
                              structure: formData.find(
                                (item: any) =>
                                  parseInt(item.key) === parseInt(lead.form_id)
                              )?.structure,
                              responses: lead.response,
                              id: lead.key,
                            })
                          }>
                          <EditIcon fontSize="small" />
                        </IconButton>
                        <Menu
                          anchorEl={anchorEl}
                          open={Boolean(anchorEl)}
                          onClose={handleMenuClose}>
                          <MenuItem onClick={handleEditLead}>
                            Edit Lead
                          </MenuItem>
                        </Menu>
                      </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <span className="d-inline-flex align-items-center">
                        <i className="ti ti-calendar me-2" />
                        Date Created
                      </span>
                      <p className="text-dark">
                        {humanReadableDate(leadDetail.createdAt, true, undefined, undefined, false)}
                      </p>
                    </div>
                    {Object.entries(leadDetail.response)
                      .filter(([key]) => !["Mobile No", "Email", "Full Name"].includes(key))
                      .map(([key, value], index) => (
                        <div
                          key={index}
                          className="d-flex align-items-center justify-content-between mb-2">
                          <span className="d-inline-flex align-items-center">
                            <i className="ti ti-info-circle me-2" />
                            {String(key).replace(/_/g, " ")}
                          </span>
                          <p className="text-dark">{String(value)}</p>
                        </div>
                      ))}
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <span className="d-inline-flex align-items-center">
                        <i className="ti ti-calendar me-2" />
                        Due Date
                      </span>
                      <p className="text-dark">
                        {humanReadableDate(leadDetail.due_date, true, undefined, undefined, false)}
                      </p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <span className="d-inline-flex align-items-center">
                        <i className="ti ti-hand-move me-2" />
                        Follow Up Reminder
                      </span>
                      <p className="text-dark">
                        {humanReadableDate(leadDetail.follow_up_date, true, undefined, undefined, false)}
                      </p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <span className="d-inline-flex align-items-center">
                        <i className="ti ti-plus me-2" />
                        Primary Source
                      </span>
                      <p className="text-dark">{leadDetail.lead_source}</p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between">
                      <span className="d-inline-flex align-items-center">
                        <i className="ti ti-plus me-2" />
                        Secondary Source
                      </span>
                      <p className="text-dark">
                        {leadDetail.lead_source_child}
                      </p>
                    </div>
                  </div>

                  <div className="p-3 border-bottom">
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <h6>Contact Info</h6>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <span className="d-inline-flex align-items-center">
                        <i className="ti ti-mail me-2" />
                        Email
                      </span>
                      <p className="text-dark">
                        {leadDetail.email != null ? leadDetail.email : "N/A"}
                      </p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between">
                      <span className="d-inline-flex align-items-center">
                        <i className="ti ti-phone me-2" />
                        Mobile No
                      </span>
                      <p className="text-dark">{leadDetail.mobile_no}</p>
                    </div>
                  </div>

                  <div className="p-3 border-bottom">
                    <h5 className="mb-3">Project</h5>
                    <div className="d-flex align-items-center">
                      <span className="badge badge-dark-transparent me-3">
                        {formDetail.find((obj: any) => parseInt(obj.key) == parseInt(leadDetail.form_id))?.LeadFormName}
                      </span>
                    </div>
                  </div>

                  <div className="p-3 border-bottom">
                    <h5 className="mb-3">Follow Up Reminder Date</h5>
                    <div className="row">
                      <div className="col-md-4">
                        <p className="text-dark">
                          {humanReadableDate(leadDetail.follow_up_date, true, undefined, undefined, false)}
                        </p>
                      </div>
                      <div className="col-md-8">
                        <p
                          style={{
                            cursor: "pointer",
                            textDecoration: "underline",
                            textAlign: "right",
                          }}
                          data-bs-toggle="modal"
                          data-bs-target="#add_follow_up">
                          Add Follow-Up Reminder
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="p-3 border-bottom">
                    <h5 className="mb-3">Priority</h5>
                    <div className="dropdown">
                      <Link
                        to="#"
                        onClick={(e: any) => e.preventDefault()}
                        className="dropdown-toggle btn-sm btn btn-white d-inline-flex align-items-center"
                        data-bs-toggle="dropdown">
                        <span className="border border-purple rounded-circle bg-soft-danger d-flex justify-content-center align-items-center me-1">
                          <i className="ti ti-point-filled text-danger" />
                        </span>
                        {priority}
                      </Link>
                      <ul
                        className="dropdown-menu dropdown-menu-end p-3 position-absolute"
                        style={{ zIndex: 1050 }}>
                        {PRIORITY_OPTIONS.map((option) => (
                          <li key={option}>
                            <Link
                              to="#"
                              onClick={(e: any) => {
                                e.preventDefault();
                                handlePriorityChange(option);
                              }}
                              className="dropdown-item rounded-1">
                              {option}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>

                  <div className="p-3">
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <h6>Other information</h6>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <span className="d-inline-flex align-items-center">
                        <i className="ti ti-calendar-check me-2" />
                        Last Modified
                      </span>
                      <p className="text-dark">
                        {humanReadableDate(leadDetail.updatedAt, true, undefined, undefined, false)}
                      </p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <span className="d-inline-flex align-items-center">
                        <i className="ti ti-user-check me-2" />
                        Assigned To
                      </span>
                      <p className="text-dark d-flex align-items-center">
                        {leadDetail?.assigned_to_details && (
                          <div className="d-flex align-items-center">
                            <span className="avatar avatar-md avatar-rounded me-1 border border-2">
                              <ImageWithBasePath
                                src={leadDetail?.assigned_to_details?.image || "assets/img/users/user.png"}
                                alt="Img"
                              />
                            </span>
                            {leadDetail?.assigned_to_details?.name || "N/F"}
                          </div>
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-8">
              <div className="bg-white rounded p-3 mb-3">
                <h4 className="fw-semibold mb-3">Pipeline Status</h4>
                <div className="pipeline-list pipeline-list-two">
                  <ul>
                    {leadDetail &&
                      pipeLineDetail?.map((stage: any) => (
                        <li key={stage}>
                          <Link
                            to="#"
                            className={
                              stage.toLowerCase() ==
                                leadDetail?.pipeline_char?.toLowerCase()
                                ? "bg-info"
                                : ""
                            }
                            onClick={(e: any) => {
                              e.preventDefault();
                              updateStage(stage);
                            }}>
                            {stage}
                          </Link>
                        </li>
                      ))}
                  </ul>
                </div>

                <ul
                  className="nav nav-tabs nav-tabs-bottom nav-justified flex-wrap"
                  role="tablist">
                  <li className="nav-item" role="presentation">
                    <Link
                      className="nav-link active fw-medium d-flex align-items-center justify-content-center"
                      to="#bottom-justified-tab1"
                      onClick={(e: any) => e.preventDefault()}
                      data-bs-toggle="tab"
                      aria-selected="false"
                      role="tab">
                      <i className="ti ti-activity me-1" />
                      Activities
                    </Link>
                  </li>
                  <li className="nav-item" role="presentation">
                    <Link
                      className="nav-link fw-medium d-flex align-items-center justify-content-center"
                      to="#bottom-justified-tab2"
                      onClick={(e: any) => e.preventDefault()}
                      data-bs-toggle="tab"
                      aria-selected="false"
                      role="tab">
                      <i className="ti ti-file-description me-1" />
                      Notes
                    </Link>
                  </li>
                  <li className="nav-item" role="presentation">
                    <Link
                      className="nav-link fw-medium d-flex align-items-center justify-content-center"
                      to="#bottom-justified-tab3"
                      onClick={(e: any) => e.preventDefault()}
                      data-bs-toggle="tab"
                      aria-selected="true"
                      role="tab">
                      <i className="ti ti-phone-call me-1" />
                      Calls
                    </Link>
                  </li>
                  <li className="nav-item" role="presentation">
                    <Link
                      className="nav-link fw-medium d-flex align-items-center justify-content-center"
                      to="#bottom-justified-tab5"
                      onClick={(e: any) => e.preventDefault()}
                      data-bs-toggle="tab"
                      aria-selected="true"
                      role="tab">
                      <i className="ti ti-mail-check me-1" />
                      Email
                    </Link>
                  </li>
                  <li className="nav-item" role="presentation">
                    <Link
                      className="nav-link fw-medium d-flex align-items-center justify-content-center"
                      to="#bottom-justified-tab6"
                      onClick={(e: any) => {
                        e.preventDefault();
                        setIsWhatsAppTabOpened(true);
                      }}
                      data-bs-toggle="tab"
                      aria-selected="false"
                      role="tab">
                      <i className="ti ti-brand-whatsapp me-1" />
                      WhatsApp
                    </Link>
                  </li>
                </ul>
              </div>

              <div className="tab-content">
                <div
                  className="tab-pane active show"
                  id="bottom-justified-tab1"
                  role="tabpanel">
                  <div className="card border-0">
                    <div className="card-header">
                      <div className="d-flex align-items-center justify-content-between">
                        <h5>Activities</h5>
                      </div>
                    </div>
                    <div className="card-body">
                      {activityLogs.map((log, index) => (
                        <div key={index}>
                          <span className="badge badge-soft-purple d-inline-flex align-items-center mb-3">
                            <i className="ti ti-calendar me-1" />
                            {humanReadableDate(log.date)}
                          </span>

                          {log.activities.map((activity) => (
                            <div
                              key={activity.id}
                              className="border rounded py-3 px-1 mb-3 row d-flex align-items-center">
                              <div className="col-md-9">
                                <div className="d-flex align-items-start">
                                  <span
                                    className={`avatar avatar-md avatar-rounded flex-shrink-0 ${activity.bgColor} me-2`}>
                                    <i className={`ti ${activity.icon} fs-20`} />
                                  </span>

                                  <div>
                                    <h6 className="fw-medium mb-1">
                                      {activity.title}
                                    </h6>
                                    {activity.description && (
                                      <p className="mb-1">
                                        {activity.type == "meeting"
                                          ? `${activity.description} ${leadDetail.response["Full Name"]}`
                                          : activity.description}
                                      </p>
                                    )}
                                    <span className="badge badge-md bg-secondary-transparent">
                                      {humanReadableDate(activity.time, true, undefined, undefined, false)}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-3">
                                {activity?.acitivityBy && (
                                  <div className="d-flex align-items-center badge badge-md bg-secondary-transparent">
                                    <span className="avatar avatar-md avatar-rounded me-1 border border-2">
                                      <ImageWithBasePath
                                        src={activity?.acitivityBy?.image || "assets/img/users/user.png"}
                                        alt="Img"
                                      />
                                    </span>
                                    <span className="small">
                                      {activity?.acitivityBy?.name}
                                    </span>
                                  </div>
                                )}
                              </div>
                            </div>
                          ))}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                <div
                  className="tab-pane"
                  id="bottom-justified-tab2"
                  role="tabpanel">
                  <div className="card border-0">
                    <div className="card-header">
                      <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                        <h5>Notes</h5>
                        <div className="d-flex align-items-center">
                          <Link
                            to="#"
                            onClick={(e: any) => e.preventDefault()}
                            className="d-inline-flex align-items-center text-primary fw-medium"
                            data-bs-toggle="modal"
                            data-bs-target="#add_notes">
                            <i className="ti ti-circle-plus me-1" />
                            Add Note
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div className="card-body">
                      {notes.map((note, index) => (
                        <div className="border rounded p-3 mb-3" key={note.id}>
                          <div className="d-flex align-items-center justify-content-between mb-3">
                            <div className="d-flex align-items-center">
                              <span className="avatar avatar-md avatar-rounded flex-shrink-0 me-2">
                                <img
                                  src={"/assets/img/reports-img/employee-report-icon.svg"}
                                  alt="Img"
                                />
                              </span>
                              <div>
                                <h6 className="fw-medium mb-1">{note.title}</h6>
                                <span>
                                  {humanReadableDate(note.date, true, undefined, undefined, false)}
                                </span>
                              </div>
                            </div>
                          </div>
                          <h6 className="fw-medium mb-2">{note.text}</h6>
                          <p className="mb-3">{note.content}</p>

                          <p className="mb-3">Comments</p>

                          {note.conversations.map((conversation: any, convIndex: any) => (
                            <div
                              key={convIndex}
                              className="bg-light-500 rounded p-3 mb-3">
                              <div className="d-flex align-items-center">
                                <span className="avatar avatar-md avatar-rounded flex-shrink-0 me-2">
                                  <img
                                    src={conversation?.profile_pic || "/assets/img/users/user.png"}
                                    alt="Img"
                                  />
                                </span>
                                <div>
                                  <h6 className="fw-medium mb-1">
                                    {conversation.name}
                                  </h6>
                                  <h6 className="mb-1">
                                    {conversation.comment}
                                  </h6>
                                  <span className="mb-1">
                                    {humanReadableDate(conversation.date, true, undefined, undefined, false)}
                                  </span>
                                </div>
                              </div>
                            </div>
                          ))}

                          <div className="notes-editor">
                            {showEditor[index] ? (
                              <div className="note-edit-wrap d-block">
                                <textarea
                                  className="form-control mb-2"
                                  placeholder="Write your comment..."
                                  value={newComments[index] || ""}
                                  onChange={(e) =>
                                    handleCommentChange(index, e.target.value)
                                  }
                                />
                                <div className="d-flex justify-content-end">
                                  <button
                                    className="btn btn-outline-light border me-3"
                                    onClick={() => handleCloseEditor(index)}>
                                    Cancel
                                  </button>
                                  <button
                                    className="btn btn-primary"
                                    onClick={() =>
                                      handleSaveComment(note.id, index)
                                    }>
                                    Save
                                  </button>
                                </div>
                              </div>
                            ) : (
                              <Link
                                to="#"
                                onClick={(e: any) => {
                                  e.preventDefault();
                                  handleOpenEditor(index);
                                }}
                                className="d-flex align-items-center justify-content-end text-primary fw-medium add-comment">
                                <i className="ti ti-circle-plus me-1" />
                                Add Comment
                              </Link>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                <div
                  className="tab-pane"
                  id="bottom-justified-tab3"
                  role="tabpanel">
                  <div className="card border-0">
                    <div className="card-header">
                      <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                        <h5>Calls</h5>
                      </div>
                    </div>
                    <div className="card-body">
                      {callLogs.map((log) => (
                        <div key={log.id} className="border rounded p-3 mb-3">
                          <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3 mb-3">
                            <div className="d-flex align-items-center">
                              <span className="avatar avatar-md avatar-rounded flex-shrink-0 me-2">
                                <ImageWithBasePath src={log.image} alt="Img" />
                              </span>
                              <div>
                                <p className="fw-medium">
                                  <span className="text-dark">{log.name}</span>{" "}
                                  logged a call on {humanReadableDate(log.dateTime, false)}
                                </p>
                              </div>
                            </div>
                          </div>

                          <div>
                            <p>{log.note}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                <div
                  className="tab-pane"
                  id="bottom-justified-tab5"
                  role="tabpanel">
                  <div className="card border-0">
                    <div className="card-header">
                      <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                        <h5>Email</h5>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="border rounded p-3">
                        <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                          <div>
                            <h6 className="fw-medium mb-1">Manage Emails</h6>
                            <p>
                              You can send and reply to emails directly via this
                              section.
                            </p>
                          </div>
                          <div>
                            <Link
                              to="#"
                              className="btn btn-primary"
                              onClick={(e: any) => e.preventDefault()}>
                              Connect Account
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane"
                  id="bottom-justified-tab6"
                  role="tabpanel">
                  <div className="card border-0">
                    <div className="card-header">
                      <h5>WhatsApp Conversation</h5>
                    </div>
                    <div className="card-body">
                      {isWhatsAppTabOpened && (leadDetail.id || leadDetail.key) && (
                        <WhatsAppConversationPanel
                          companyId={leadDetail.company_id}
                          companyType={leadDetail.company_type}
                          leadResponseId={Number(leadDetail.id || leadDetail.key)}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>)}


        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2025 © CMS.</p>
          <p>
            Designed & Developed By{" "}
            <Link
              to="#"
              onClick={(e: any) => e.preventDefault()}
              className="text-primary">
              ZYVO
            </Link>
          </p>
        </div>
      </div>

      <AddNOtes data={leadDetail} onNotesAdded={handleNotesAdded} />

      <div className="modal fade" id="add_follow_up" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header header-border align-items-center justify-content-between">
              <h5 className="modal-title">Create Follow Up Reminder</h5>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close">
                <i className="ti ti-x" />
              </button>
            </div>
            <form>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-6">
                    <div className="mb-3">
                      <DatePicker
                        className="form-control datetimepicker"
                        format="DD-MM-YYYY HH:mm"
                        showTime={{ format: "HH:mm" }}
                        value={selectedDate}
                        onChange={handleDateChange}
                        placeholder="DD-MM-YYYY HH:mm"
                        disabledDate={(current) =>
                          !!current &&
                          current.valueOf() < new Date().setHours(0, 0, 0, 0)
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  data-bs-dismiss="modal"
                  className="btn btn-outline-light border me-2"
                  aria-label="Close">
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSubmit}>
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div
        className={`modal fade ${showStageReminderModal ? 'show' : ''}`}
        id="stage_follow_up"
        style={{ display: showStageReminderModal ? 'block' : 'none' }}
        role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header header-border align-items-center justify-content-between">
              <h5 className="modal-title">Add Follow-Up Reminder</h5>
              {/* <button
                type="button"
                className="btn-close custom-btn-close"
                onClick={handleStageReminderSkip}
                aria-label="Close">
                <i className="ti ti-x" />
              </button> */}
            </div>
            <form onSubmit={(e) => { e.preventDefault(); handleStageReminderSubmit(); }}>
              <div className="modal-body">
                <p className="text-muted mb-3">
                  Stage updated to <strong>{pendingStageChange}</strong>.
                  Set a reminder for follow-up?
                </p>
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">Follow-up Date & Time</label>
                      <DatePicker
                        className="form-control datetimepicker w-100"
                        format="DD-MM-YYYY HH:mm"
                        showTime={{ format: "HH:mm" }}
                        value={selectedDate}
                        onChange={handleDateChange}
                        placeholder="DD-MM-YYYY HH:mm"
                        disabledDate={(current) =>
                          !!current &&
                          current.valueOf() < new Date().setHours(0, 0, 0, 0)
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                {/* <button
                  type="button"
                  onClick={handleStageReminderSkip}
                  className="btn btn-outline-light border me-2">
                  Skip
                </button> */}
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={!selectedDate}>
                  Save Reminder
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {showStageReminderModal && <div className="modal-backdrop fade show"></div>}

      {selectedLead && (
        <EditLead
          open={isEditOpen}
          onClose={handleCloseEdit}
          updateUI={handleUpdateLead}
          data={[selectedLead]}
        />
      )}
    </>
  );
};

export default LeadsDetails;
